import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import SearchResults from '../../components/Search/SearchResults';
import searchService from '../../api/services/searchService';

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (query) {
      performSearch(query);
    }
  }, [query]);

  const performSearch = async (searchQuery) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await searchService.search(searchQuery);
      setResults(response.data || []);
    } catch (err) {
      console.error('Erreur recherche:', err);
      setError(err.message || 'Erreur lors de la recherche');
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleResultClick = (result) => {
    // Navigation selon le type de résultat
    const routes = {
      agent: `/agents/${result.id}`,
      conversation: `/conversations/${result.id}`,
      product: `/produits/${result.id}`,
      order: `/commandes/${result.id}`,
      knowledge: `/base-connaissance/${result.id}`
    };

    const route = routes[result.type];
    if (route) {
      window.location.href = route;
    }
  };

  return (
    <SearchResults
      query={query}
      results={results}
      loading={loading}
      error={error}
      onResultClick={handleResultClick}
    />
  );
}
